import React, { useState, useEffect } from 'react';
import { updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import '../shared.css';

const PasswordChange = () => {
  const [oldPassword,     setOldPassword]     = useState('');
  const [newPassword,     setNewPassword]     = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMessage,  setSuccessMessage]  = useState('');
  const [errorMessage,    setErrorMessage]    = useState('');

  const { isAuthenticated, userId, logout, token } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) logout();
  }, [isAuthenticated, token, logout]);

  const validate = () => {
    if (newPassword.length < 8)          { setErrorMessage('Password must be at least 8 characters long.');       return false; }
    if (!/[A-Z]/.test(newPassword))      { setErrorMessage('Password must contain at least one uppercase letter.'); return false; }
    if (!/[a-z]/.test(newPassword))      { setErrorMessage('Password must contain at least one lowercase letter.'); return false; }
    if (!/\d/.test(newPassword))         { setErrorMessage('Password must contain at least one digit.');           return false; }
    if (newPassword !== confirmPassword) { setErrorMessage('Passwords do not match.');                             return false; }
    setErrorMessage('');
    return true;
  };

  const handleChangePassword = () => {
    if (!validate()) return;

    const payload = {
      CurrentPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
      UserId: userId,
    };

    updateData('UserTokenApi', `${userId}`, payload, token)
      .then(response => {
        setSuccessMessage(response.message);
        if (response.responseCode === '1111') logout();
      })
      .catch(err => {
        setErrorMessage('Failed to change password. Please try again.');
        console.error('Password Change error:', err);
      });
  };

  return (
    <div className="pg-container">
      {/* ── Header ── */}
      <div className="pg-header">
        <h5 className="pg-title">Password Change</h5>
        <div className="pg-action-row">
          <button className="pg-btn pg-btn-success" onClick={handleChangePassword}>
            <DoneIcon /> Change Password
          </button>
        </div>
      </div>

      {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
      {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

      {/* ── Form ── */}
      <div className="pg-card" style={{ maxWidth: 420 }}>
        <div className="pg-form-grid" style={{ gridTemplateColumns: '1fr' }}>
          <div className="pg-field">
            <label className="pg-label">Old Password <span className="req">*</span></label>
            <input
              className="pg-input"
              type="password"
              value={oldPassword}
              onChange={e => setOldPassword(e.target.value)}
              placeholder="Enter current password"
            />
          </div>

          <div className="pg-field">
            <label className="pg-label">New Password <span className="req">*</span></label>
            <input
              className="pg-input"
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </div>

          <div className="pg-field">
            <label className="pg-label">Confirm Password <span className="req">*</span></label>
            <input
              className="pg-input"
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
          </div>
        </div>
      </div>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default PasswordChange;
